import { Callout, type CalloutVariant } from '@/_shared/components/ui/callout';
import { useSiblingStatus } from '@/_shared/hooks/useSiblingStatus';

const VARIANT: Record<string, CalloutVariant> = {
  paused: 'warning',
  pending: 'info',
  disabled: 'warning',
  missing: 'error',
};

/**
 * The one workspace-level banner of a sibling workspace (ACT2-1124 LLD §5.9): paused, still setting up, disabled
 * or gone. The server owns the text and decides when it shows; a shared-key workspace never shows one.
 */
export function SiblingStatusBanner(): React.ReactElement | null {
  const status = useSiblingStatus();
  if (!status?.banner || !status.state) return null;
  return (
    <div className="border-b border-border bg-background px-4 py-2" data-slot="sibling-status-banner">
      <Callout variant={VARIANT[status.state] ?? 'info'} role="status">
        {status.banner}
      </Callout>
    </div>
  );
}
